"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const beerCategories = [{
  title: "Operatörsprogrammet",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_light_trails_1.png",
  link: "/BecomeOperatorPage"
}, {
  title: "Robotaxi Nätverket",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_light_trails_2.png",
  link: "/RobotaxiPage"
}, {
  title: "Marknadsinsikter",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_light_trails_3.png",
  link: "/InsightsPage"
}, {
  title: "Försäkringsförmåner",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_light_trails_4.png",
  link: "/CheaperInsurancePage"
}];
export default function DiscoverItalianBrewingArt() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="108524" id="hero" className="bg-background text-foreground py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif font-bold text-4xl md:text-5xl lg:text-[48px] text-white mb-6 tracking-tight">
            Bli en Pionjär inom Robotaxi
          </h1>
          <p className="font-sans text-lg md:text-[18px] text-white/80 leading-relaxed">
            En exklusiv möjlighet att ansluta din Tesla till det autonoma nätverket. 
            Maximera din avkastning och ta täten i den nya mobilitetsekonomin i Sverige.
          </p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {beerCategories.map((category, i) => <div key={category.title} data-index={i} className="group relative overflow-hidden aspect-[4/3] md:aspect-[3/2] bg-muted shadow-lg">
              {}
              <img src={category.image} alt={category.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" />

              {}
              <div className="absolute inset-0 bg-slate-900/40 transition-colors duration-500 group-hover:bg-slate-900/60" />

              {}
              <div className="absolute inset-0 flex items-center justify-center p-6 pointer-events-none">
                <h2 className="font-serif font-bold text-3xl md:text-4xl lg:text-5xl text-white text-center drop-shadow-lg">
                  {category.title}
                </h2>
              </div>

              {}
              <div className="absolute bottom-8 left-0 right-0 flex justify-center">
                <Button asChild variant="default" size="lg" className="rounded-[3px] bg-primary text-white font-sans font-semibold tracking-wide uppercase shadow-xl transition-transform duration-300 hover:-translate-y-1">
                  <Link to={category.link}>Registrera Intresse</Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}